import React from "react";
import styles from "./styles/StatisticItem.scss";

export default function StatisticItem({ title, value, background, link }) {
  return (
    <a className={styles.container} href={link} target="_blank">
      <span className={styles.title}>{title}</span>
      <span className={styles.value} style={{ background }}>
        {value}
      </span>
    </a>
  );
}



// WEBPACK FOOTER //
// ./src/containers/UserProfilePage/StatisticItem.tsx